import { FormFieldTypes } from "../../../../../data/formFieldType";

export const speakingTeachingEngagementData = {
    name: 'SpeakingTeachingEngagement',
    initialState: {
        typeofCourseEvent: "",
        nameofEventOrganiser: "",
        dateofCourseEvent: "",
        letterEmailofAppointmentInvitation: "",
        // awardRating: "",
        CpdPoints: "",
        remarks: "",
        processedBy: "",
        cpdPointsAwarded: "",
        notes: "",
        rejectionReason:""
    },
    formFields: [
        {
            id: "course/EventInformation",
            lable: "",
            Field_Name: "course/EventInformation",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "course/EventInformation",
            fieldSetting: {
                formTitle: "Course/Event Information",
            },
            style: {
                containerCss: "col-lg-12 mb-4 text-left",
            },
        },
        {
            id: "typeofCourseEvent",
            lable: "Type of Course/Event",
            Field_Name: "Type of Course/Event",
            fieldType: FormFieldTypes.INPUT,
            dataField: "typeofCourseEvent",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        {
            id: "nameofEventOrganiser",
            lable: "Name of Event Organiser",
            Field_Name: "Name of Event Organiser",
            fieldType: FormFieldTypes.INPUT,
            dataField: "nameofEventOrganiser",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space",
            },
        },
        {
            id: "dateofCourseEvent",
            lable: "Date of Course/Event",
            Field_Name: "Date of Course/Event",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "dateofCourseEvent",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        {
            id: "certificateofAttendance",
            lable: 'Proof of Attendance and Presentation Slides/Content with Duration of Speech',
            subLable: '(please upload in PDF format max 2mb)',
            Field_Name: 'file',
            fieldType: FormFieldTypes.FILE,
            dataField: 'letterEmailofAppointmentInvitation',
            fieldSetting: {
                // presentFileName: null,
                isDownloadable: true,
                acceptedFiles: '.pdf',
                maxFileSizeInKB: 2048,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
            }
        },
        // {
        //     id: "awardRating",
        //     lable: "Award Rating",
        //     Field_Name: "Award Rating",
        //     fieldType: FormFieldTypes.SELECT,
        //     dataField: "awardRating",
        //     fieldSetting: {
        //         placeholder: "",
        //         options: []
        //     },
        //     validation: [{ type: "require" }],
        //     style: {
        //         containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space"
        //     }
        // },
        // {
        //     fieldType: FormFieldTypes.SEPARATOR,
        //     style: {
        //         containerCss: "separation-line pl-0 pr-0",
        //     },
        // },
        {
            id: "CpdPoints",
            lable: "CPD Points",
            Field_Name: "CPD Points",
            fieldType: FormFieldTypes.INPUT,
            dataField: "CpdPoints",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space",
            },
        },
        {
            id: "remarks",
            lable: "Remarks",
            Field_Name: "Remarks",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "remarks",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            // validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 col-12 input-margin-space",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "sgbcSection",
            lable: "",
            Field_Name: "sgbcSection",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "sgbcSection",
            fieldSetting: {
                formTitle: "SGBC Section",
            },
            style: {
                containerCss: "col-lg-12 mb-4 text-left",
            },
        },
        {
            id: "processedBy",
            lable: "Processed by",
            Field_Name: "Processed by",
            fieldType: FormFieldTypes.SELECT,
            dataField: "processedBy",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6  "
            }
        },
        {
            id: "cpdPointsAwarded",
            lable: "CPD Points Awarded",
            Field_Name: "CPD Points Awarded ",
            fieldType: FormFieldTypes.SELECT,
            dataField: "cpdPointsAwarded",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6"
            }
        },
        {
            id: "notes",
            lable: "Notes",
            Field_Name: "Notes",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "notes",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3",
            },
        },
        {
            id: "rejectionReason",
            lable: "Rejection Reason",
            Field_Name: "rejectionReason",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "rejectionReason",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 4000,
            },
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3",
            },
        }

    ],
    formSetting: {
        isViewOnly: false
    }
}